<!-- 纵向布局 -->
<script lang="ts" setup>
defineProps({
  collapse: {
    type: Boolean,
    default() {
      return false
    },
  },
  fixedHeader: {
    type: Boolean,
    default() {
      return true
    },
  },
  showTabs: {
    type: Boolean,
    default() {
      return true
    },
  },
  device: {
    type: String,
    default() {
      return 'desktop'
    },
  },
})
</script>

<template>
  <div
    class="sjzy-layout-vertical"
    :class="{
      'no-tabs-bar': !showTabs,
    }"
  >
    <LayoutRouterView />
  </div>
</template>
